import { DealOfferTags } from "@/components/marketplace/deal-offer-tags";
import type { OfferSummary } from "@/components/marketplace/offer-summary-badge";
import { useOfferMediaPacking } from "@/components/marketplace/useOfferMediaPacking";

export function OfferSummaryMetadata({ offer }: { offer: OfferSummary }) {
  const packing = useOfferMediaPacking(
    offer.releaseMediaFormatSummary,
    offer.bestOfferFormatCategory,
  );
  return (
    <>
      <p className="mt-1 text-xs leading-snug text-muted-foreground [overflow-wrap:anywhere]">
        {packing}
      </p>
      {offer.tags.length > 0 && (
        <div className="mt-1 flex flex-wrap gap-1.5">
          <DealOfferTags tags={offer.tags} />
        </div>
      )}
    </>
  );
}
